import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Hello from '@/components/Hello'
import Patient from '@/components/Patient'
import Exudats from '@/components/Exudats'
import Proliferation from '@/components/Proliferation'
import TrashBin from '@/components/TrashBin'
// import Compound from '@/components/Compound'
// import WE from '@/components/WE'
import Properties from '@/components/Properties'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/patient/:id?',
      name: 'patient',
      component: Patient
    },
    {
      path: '/exudats',
      name: 'exudats',
      component: Exudats,
      redirect: '/exudats/proliferation',
      children: [
        {
          path: ':experiment/:id?',
          name: 'experiment',
          component: Proliferation
        }
      ]
    },
    {
      path: '/patient-properties/:db_id/:id?',
      name: 'properties',
      component: Properties
    },
    {
      path: '/trash-bin/:site?/:table',
      name: 'trash',
      component: TrashBin
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js